var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class DataApiDebug extends Component {
    constructor() {
        super('DataApiDebug', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            DataApiDebug.isEnabled = $('#data-api-debug').length > 0;
            $('.data-api-debug-timer').each((element) => {
                const name = $(element).find('span').first().text();
                const value = $(element).find('span').last().text();
                DataApiDebug.log(`${name}: ${value} seconds`);
            });
            this.success();
        });
    }
    static log(message) {
        if (!DataApiDebug.isEnabled)
            return;
        console.log(`Data API Debug ${message}`);
    }
    static timer_start(name) {
        DataApiDebug.timers[name] = Date.now();
    }
    static timer_end(name) {
        if (!DataApiDebug.timers[name])
            return;
        const duration = (Date.now() - DataApiDebug.timers[name]) / 1000;
        DataApiDebug.timers[name] = 0;
        DataApiDebug.log(`${name}: ${duration} seconds`);
    }
}
DataApiDebug.isEnabled = false;
DataApiDebug.timers = {};
